// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"FormError_paragraph__38T5s","isVisible":"FormError_isVisible__2AKMZ","isCentered":"FormError_isCentered__1LjOE"};